import Widget from "csi/table/Widget";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const GroupByParentTable = declare(Widget, {
	/**
	 * @override
	 * Default Table View to Group by __Parent__
	 */
	onCreateDefaultCustomView(cv) {
		this.inherited(arguments);
		this.setDefaultGroupAndExpand(xml.ATTR_PARENT);
	},
});

export = GroupByParentTable;